/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CreateSiteRequestDto,
  GetSiteAssetsMapResponseDto,
  GetSiteOperationsMapResponseDto,
  ListCitiesResponseDto,
  ListProvincesResponseDto,
  ListSitesResponseDto,
  SiteLookupResponseDto,
  UpdateSiteRequestDto,
} from '../models/index';
import {
    CreateSiteRequestDtoFromJSON,
    CreateSiteRequestDtoToJSON,
    GetSiteAssetsMapResponseDtoFromJSON,
    GetSiteAssetsMapResponseDtoToJSON,
    GetSiteOperationsMapResponseDtoFromJSON,
    GetSiteOperationsMapResponseDtoToJSON,
    ListCitiesResponseDtoFromJSON,
    ListCitiesResponseDtoToJSON,
    ListProvincesResponseDtoFromJSON,
    ListProvincesResponseDtoToJSON,
    ListSitesResponseDtoFromJSON,
    ListSitesResponseDtoToJSON,
    SiteLookupResponseDtoFromJSON,
    SiteLookupResponseDtoToJSON,
    UpdateSiteRequestDtoFromJSON,
    UpdateSiteRequestDtoToJSON,
} from '../models/index';

export interface OrganizationSiteControllerCreateSiteRequest {
    organizationId: string;
    createSiteRequestDto: CreateSiteRequestDto;
}

export interface OrganizationSiteControllerDeleteSiteRequest {
    siteId: string;
    organizationId: string;
}

export interface OrganizationSiteControllerFindSiteAssetsMapByIdRequest {
    siteId: string;
    organizationId: string;
}

export interface OrganizationSiteControllerFindSiteOperationsMapByOrganizationIdRequest {
    organizationId: string;
}

export interface OrganizationSiteControllerFindSitesByOrganizationIdRequest {
    limit: number;
    page: number;
    organizationId: string;
    q?: string;
}

export interface OrganizationSiteControllerUpdateSiteRequest {
    siteId: string;
    organizationId: string;
    updateSiteRequestDto: UpdateSiteRequestDto;
}

export interface SiteControllerListCitiesRequest {
    limit: number;
    page: number;
    provinceCode?: string;
    q?: string;
}

export interface SiteControllerListProvincesRequest {
    limit: number;
    page: number;
    q?: string;
}

/**
 * 
 */
export class SitesApi extends runtime.BaseAPI {

    /**
     */
    async organizationSiteControllerCreateSiteRaw(requestParameters: OrganizationSiteControllerCreateSiteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SiteLookupResponseDto>> {
        if (requestParameters['organizationId'] == null) {
            throw new runtime.RequiredError(
                'organizationId',
                'Required parameter "organizationId" was null or undefined when calling organizationSiteControllerCreateSite().'
            );
        }

        if (requestParameters['createSiteRequestDto'] == null) {
            throw new runtime.RequiredError(
                'createSiteRequestDto',
                'Required parameter "createSiteRequestDto" was null or undefined when calling organizationSiteControllerCreateSite().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/organizations/{organizationId}/sites`;
        urlPath = urlPath.replace(`{${"organizationId"}}`, encodeURIComponent(String(requestParameters['organizationId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateSiteRequestDtoToJSON(requestParameters['createSiteRequestDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SiteLookupResponseDtoFromJSON(jsonValue));
    }

    /**
     */
    async organizationSiteControllerCreateSite(requestParameters: OrganizationSiteControllerCreateSiteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SiteLookupResponseDto> {
        const response = await this.organizationSiteControllerCreateSiteRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async organizationSiteControllerDeleteSiteRaw(requestParameters: OrganizationSiteControllerDeleteSiteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['siteId'] == null) {
            throw new runtime.RequiredError(
                'siteId',
                'Required parameter "siteId" was null or undefined when calling organizationSiteControllerDeleteSite().'
            );
        }

        if (requestParameters['organizationId'] == null) {
            throw new runtime.RequiredError(
                'organizationId',
                'Required parameter "organizationId" was null or undefined when calling organizationSiteControllerDeleteSite().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/organizations/{organizationId}/sites/{siteId}`;
        urlPath = urlPath.replace(`{${"siteId"}}`, encodeURIComponent(String(requestParameters['siteId'])));
        urlPath = urlPath.replace(`{${"organizationId"}}`, encodeURIComponent(String(requestParameters['organizationId'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async organizationSiteControllerDeleteSite(requestParameters: OrganizationSiteControllerDeleteSiteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.organizationSiteControllerDeleteSiteRaw(requestParameters, initOverrides);
    }

    /**
     */
    async organizationSiteControllerFindSiteAssetsMapByIdRaw(requestParameters: OrganizationSiteControllerFindSiteAssetsMapByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetSiteAssetsMapResponseDto>> {
        if (requestParameters['siteId'] == null) {
            throw new runtime.RequiredError(
                'siteId',
                'Required parameter "siteId" was null or undefined when calling organizationSiteControllerFindSiteAssetsMapById().'
            );
        }

        if (requestParameters['organizationId'] == null) {
            throw new runtime.RequiredError(
                'organizationId',
                'Required parameter "organizationId" was null or undefined when calling organizationSiteControllerFindSiteAssetsMapById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/organizations/{organizationId}/sites/{siteId}/assets-map`;
        urlPath = urlPath.replace(`{${"siteId"}}`, encodeURIComponent(String(requestParameters['siteId'])));
        urlPath = urlPath.replace(`{${"organizationId"}}`, encodeURIComponent(String(requestParameters['organizationId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetSiteAssetsMapResponseDtoFromJSON(jsonValue));
    }

    /**
     */
    async organizationSiteControllerFindSiteAssetsMapById(requestParameters: OrganizationSiteControllerFindSiteAssetsMapByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetSiteAssetsMapResponseDto> {
        const response = await this.organizationSiteControllerFindSiteAssetsMapByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async organizationSiteControllerFindSiteOperationsMapByOrganizationIdRaw(requestParameters: OrganizationSiteControllerFindSiteOperationsMapByOrganizationIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetSiteOperationsMapResponseDto>> {
        if (requestParameters['organizationId'] == null) {
            throw new runtime.RequiredError(
                'organizationId',
                'Required parameter "organizationId" was null or undefined when calling organizationSiteControllerFindSiteOperationsMapByOrganizationId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/organizations/{organizationId}/sites/operations-map`;
        urlPath = urlPath.replace(`{${"organizationId"}}`, encodeURIComponent(String(requestParameters['organizationId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetSiteOperationsMapResponseDtoFromJSON(jsonValue));
    }

    /**
     */
    async organizationSiteControllerFindSiteOperationsMapByOrganizationId(requestParameters: OrganizationSiteControllerFindSiteOperationsMapByOrganizationIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetSiteOperationsMapResponseDto> {
        const response = await this.organizationSiteControllerFindSiteOperationsMapByOrganizationIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async organizationSiteControllerFindSitesByOrganizationIdRaw(requestParameters: OrganizationSiteControllerFindSitesByOrganizationIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListSitesResponseDto>> {
        if (requestParameters['limit'] == null) {
            throw new runtime.RequiredError(
                'limit',
                'Required parameter "limit" was null or undefined when calling organizationSiteControllerFindSitesByOrganizationId().'
            );
        }

        if (requestParameters['page'] == null) {
            throw new runtime.RequiredError(
                'page',
                'Required parameter "page" was null or undefined when calling organizationSiteControllerFindSitesByOrganizationId().'
            );
        }

        if (requestParameters['organizationId'] == null) {
            throw new runtime.RequiredError(
                'organizationId',
                'Required parameter "organizationId" was null or undefined when calling organizationSiteControllerFindSitesByOrganizationId().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['q'] != null) {
            queryParameters['q'] = requestParameters['q'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/organizations/{organizationId}/sites`;
        urlPath = urlPath.replace(`{${"organizationId"}}`, encodeURIComponent(String(requestParameters['organizationId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ListSitesResponseDtoFromJSON(jsonValue));
    }

    /**
     */
    async organizationSiteControllerFindSitesByOrganizationId(requestParameters: OrganizationSiteControllerFindSitesByOrganizationIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListSitesResponseDto> {
        const response = await this.organizationSiteControllerFindSitesByOrganizationIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async organizationSiteControllerUpdateSiteRaw(requestParameters: OrganizationSiteControllerUpdateSiteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SiteLookupResponseDto>> {
        if (requestParameters['siteId'] == null) {
            throw new runtime.RequiredError(
                'siteId',
                'Required parameter "siteId" was null or undefined when calling organizationSiteControllerUpdateSite().'
            );
        }

        if (requestParameters['organizationId'] == null) {
            throw new runtime.RequiredError(
                'organizationId',
                'Required parameter "organizationId" was null or undefined when calling organizationSiteControllerUpdateSite().'
            );
        }

        if (requestParameters['updateSiteRequestDto'] == null) {
            throw new runtime.RequiredError(
                'updateSiteRequestDto',
                'Required parameter "updateSiteRequestDto" was null or undefined when calling organizationSiteControllerUpdateSite().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/organizations/{organizationId}/sites/{siteId}`;
        urlPath = urlPath.replace(`{${"siteId"}}`, encodeURIComponent(String(requestParameters['siteId'])));
        urlPath = urlPath.replace(`{${"organizationId"}}`, encodeURIComponent(String(requestParameters['organizationId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateSiteRequestDtoToJSON(requestParameters['updateSiteRequestDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SiteLookupResponseDtoFromJSON(jsonValue));
    }

    /**
     */
    async organizationSiteControllerUpdateSite(requestParameters: OrganizationSiteControllerUpdateSiteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SiteLookupResponseDto> {
        const response = await this.organizationSiteControllerUpdateSiteRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async siteControllerListCitiesRaw(requestParameters: SiteControllerListCitiesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListCitiesResponseDto>> {
        if (requestParameters['limit'] == null) {
            throw new runtime.RequiredError(
                'limit',
                'Required parameter "limit" was null or undefined when calling siteControllerListCities().'
            );
        }

        if (requestParameters['page'] == null) {
            throw new runtime.RequiredError(
                'page',
                'Required parameter "page" was null or undefined when calling siteControllerListCities().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['provinceCode'] != null) {
            queryParameters['provinceCode'] = requestParameters['provinceCode'];
        }

        if (requestParameters['q'] != null) {
            queryParameters['q'] = requestParameters['q'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/sites/cities`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ListCitiesResponseDtoFromJSON(jsonValue));
    }

    /**
     */
    async siteControllerListCities(requestParameters: SiteControllerListCitiesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListCitiesResponseDto> {
        const response = await this.siteControllerListCitiesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async siteControllerListProvincesRaw(requestParameters: SiteControllerListProvincesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListProvincesResponseDto>> {
        if (requestParameters['limit'] == null) {
            throw new runtime.RequiredError(
                'limit',
                'Required parameter "limit" was null or undefined when calling siteControllerListProvinces().'
            );
        }

        if (requestParameters['page'] == null) {
            throw new runtime.RequiredError(
                'page',
                'Required parameter "page" was null or undefined when calling siteControllerListProvinces().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['q'] != null) {
            queryParameters['q'] = requestParameters['q'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/sites/provinces`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ListProvincesResponseDtoFromJSON(jsonValue));
    }

    /**
     */
    async siteControllerListProvinces(requestParameters: SiteControllerListProvincesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListProvincesResponseDto> {
        const response = await this.siteControllerListProvincesRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
